export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15037.92b718b4.jpg";